import { useEffect } from 'react';
import toast from 'react-hot-toast';

import styled from '@emotion/styled';

import { PrimaryBlackButton, PrimaryWhiteButton } from '../../../components/Button/Buttons';
import { ActionRow, LoadingText, Section, SectionTitle } from '../../../components/Detail/DetailParts';
import useDisputeRecord from '../../../hooks/dashboard/schedules/useDisputeRecord';

// D30: one page answers a chargeback on a scheduled charge — the PIN-confirmed
// consent, every change, the advance notice and the result — and Export
// saves it as plain text to send to Paystack.
const DisputeRecord: React.FC<{ reference: string }> = ({ reference }) => {
  const { record, loading, load } = useDisputeRecord();

  useEffect(() => {
    load(reference);
    // eslint-disable-next-line
  }, [reference]);

  const exportText = () => {
    if (!record) return;
    const blob = new Blob([record.text + '\n'], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `hethera-dispute-${record.transaction_reference}.txt`;
    link.click();
    URL.revokeObjectURL(url);
  };

  const copyText = async () => {
    if (!record) return;
    try {
      await navigator.clipboard.writeText(record.text);
      toast.success('Copied');
    } catch {
      toast.error('Copy failed: use Export instead');
    }
  };

  return (
    <Section>
      <SectionTitle>Dispute record</SectionTitle>
      {loading || !record ? (
        <LoadingText>Loading…</LoadingText>
      ) : (
        <>
          <RecordText>{record.text}</RecordText>
          <ActionRow>
            <PrimaryBlackButton type='button' onClick={exportText}>
              Export
            </PrimaryBlackButton>
            <PrimaryWhiteButton type='button' onClick={copyText}>
              Copy
            </PrimaryWhiteButton>
          </ActionRow>
        </>
      )}
    </Section>
  );
};

export default DisputeRecord;

const RecordText = styled.pre`
  white-space: pre-wrap;
  word-break: break-word;
  font-family: inherit;
  font-size: 13px;
  line-height: 1.5;
  color: #0E1A13;
  background-color: #FAF9F5;
  border: 1px solid #E2DED3;
  border-radius: 8px;
  padding: 12px;
  margin: 0;
`;
